import { useState } from 'react';

/**
 * Persistent viewer stack visibility flags, extracted verbatim from App.tsx
 * (structural phase 1, slice C). Viewers stay mounted once rendered (hasRendered*)
 * and are shown/hidden via the show* flags. Pure state ownership — every effect and
 * handler that drives these flags stays in App.tsx, which destructures the return
 * under the original names.
 */
export const useViewerStack = () => {
  const [show3DViewer, setShow3DViewer] = useState(false);
  const [showWorkingE57Viewer, setShowWorkingE57Viewer] = useState(false);
  const [showGEOTIFFViewer, setShowGEOTIFFViewer] = useState(false);
  // const [showDWGViewer, setShowDWGViewer] = useState(false); // Commented out - using GEOTIFF instead
  const [showAutodeskViewer, setShowAutodeskViewer] = useState(false);
  const [hasRendered3DViewer, setHasRendered3DViewer] = useState(false);
  const [hasRenderedE57Viewer, setHasRenderedE57Viewer] = useState(false);
  const [hasRenderedGEOTIFFViewer, setHasRenderedGEOTIFFViewer] = useState(false);
  const [hasRenderedAutodeskViewer, setHasRenderedAutodeskViewer] = useState(false);
  // const [hasRenderedDWGViewer, setHasRenderedDWGViewer] = useState(false); // Commented out - using GEOTIFF instead

  return {
    show3DViewer,
    setShow3DViewer,
    showWorkingE57Viewer,
    setShowWorkingE57Viewer,
    showGEOTIFFViewer,
    setShowGEOTIFFViewer,
    showAutodeskViewer,
    setShowAutodeskViewer,
    hasRendered3DViewer,
    setHasRendered3DViewer,
    hasRenderedE57Viewer,
    setHasRenderedE57Viewer,
    hasRenderedGEOTIFFViewer,
    setHasRenderedGEOTIFFViewer,
    hasRenderedAutodeskViewer,
    setHasRenderedAutodeskViewer
  };
};
